import { createActionTypes } from '../../../../util/createActionsHelpers';

export const ADD_ARTICLE = createActionTypes('ADD_ARTICLE');
